import { render, staticRenderFns } from "./AssetEditorDialog.vue?vue&type=template&id=a2b87a4c&"
import script from "./AssetEditorDialog.vue?vue&type=script&lang=js&"
export * from "./AssetEditorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports